import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Table from "components/Table/Table.js";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import CSVReader from "react-csv-reader";
import SomeSpinner from "components/Somespinner/Somespinner.js"
import { makeStyles } from "@material-ui/core/styles";
import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles2 = makeStyles(styles2);

const styles = {
    margintp: {
        textAlign: "right",
        marginTop: "10px"
    }
};

const useStyles = makeStyles(styles);

function ModalCreateNf(props) {


    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const papaparseOptions = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };

    const classes2 = useStyles2();
    const [br, setBR] = React.useState(false);

    const [responseUri, setResponseUri] = useState("");
    const [loading, setLoading] = useState(false);
    const [data1, setData1] = useState([]);
    const [products, setProducts] = useState([]);
    const [productId, setProductId] = useState();
    const [price, setPrice] = useState(null);
    const [amount, setAmount] = useState();
    const [list, setList] = useState([]);
    const [practicePrice, setPraticePrice] = useState();
    const [startDate, setStartDate] = useState(new Date().withoutTime());
    const [totalList, setTotalList] = useState(0);
    const [listProducts, setListProducts] = useState([]);
    const [controlSnack, setControlSnack] = useState(false);
    const [stored, setStored] = useState(0);
    const [url, setUrl] = useState("");
    const { storageId } = useAuth();

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };


    useEffect(() => {
        loadProducts();
    }, []);


    useEffect(() => {
        if (controlSnack) showNotification("br");
    }, [controlSnack]);

    useEffect(() => {
        setList(listProducts);
    }, [listProducts, totalList])


    async function addToList(e) {
        e.preventDefault();
        let devolutionNf;
        if (amount === undefined || amount <= 0) {
            return alert('Quantidade inválida');
        }
        const id_product = productId ? parseInt(productId) : products[0].id

        let theProduct;
        for (let i = 0; i < products.length; i++) {
            if (products[i].id === id_product) {
                theProduct = products[i];
                break;
            }
        }
        const index = products.indexOf(theProduct);
        const name = products[index].name;
        let price2;

        if (price) {
            price2 = price;
        } else {
            price2 = products[index].standart_price;
        }

        devolutionNf = { amount, code: products[index].code, name, price: price2, date: startDate }

        setListProducts(prevDevolutionNf => ([...prevDevolutionNf, devolutionNf]));

    }


    async function deleteToList(index) {
        let listNew = [...listProducts];
        listNew.splice(index, 1);
        setListProducts(listNew);
    }

    async function loadProducts() {
        const response = await api.get('/product/admin/' + storageId);
        let prod = [];
        for (let i = 0; i < response.data.length; i++) {
            if (!response.data[i].name.includes('PARME')) {
                prod.push(response.data[i]);
            }
        }
        setProducts(prod);
    }


    async function handleAddDevolutionNf(e) {
        try {
            e.preventDefault();
            setLoading(true);
            const response = await api.post('/nfe', {
                data: list
            });
            setResponseUri(response.data.id);

            setTimeout(() => { setLoading(false) }, 5000);
            setControlSnack(true);
            setControlSnack(false);

        } catch (error) {
            setLoading(false);
            alert(error.response.data.error);
        }
    }

    async function setLink() {
        setLoading(true);
        const response = await api.get('/nfe/pdf/' + responseUri)
        if (response.status === 200) {
            setUrl(response.data);
            setLoading(false);
        }
    }

    async function openLink() {
        window.open(url);
    }

    async function cleanList() {
        let listNew = [];
        setListProducts(listNew);
    }

    function getNf(list) {
        let teste = [];
        for (let i = 0; i < list.length; i++) {
            teste[i] = [];
            teste[i].push(list[i].amount)
            teste[i].push(list[i].name)
            teste[i].push(<div className={classes2.tableActions}>
                <Tooltip
                    id="tooltip-top-start"
                    title="Deletar"
                    placement="top"
                    classes={{ tooltip: classes2.tooltip }}
                >
                    <IconButton
                        aria-label="Close"
                        className={classes2.tableActionButton}
                        onClick={() => deleteToList(i)}
                    >
                        <Close
                            className={
                                classes2.tableActionButtonIcon + " " + classes2.close
                            }
                        />
                    </IconButton>
                </Tooltip>
            </div>)
        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Criar nota de devolução
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={addToList}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridProduct">
                            <Form.Label>Produtos</Form.Label>
                            <Form.Control onChange={event => setProductId(event.target.value)} as="select" defaultValue="Choose...">
                                {products.map(product => (
                                    <option key={product.id} value={product.id}>{product.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Quantidade</Form.Label>
                            <Form.Control onChange={event => setAmount(event.target.value)} type="double" placeholder="Quantidade de produtos" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPrice">
                            <Form.Label>Preço do produto</Form.Label>
                            <Form.Control onChange={event => setPrice(event.target.value)} type="double" placeholder="Caso vazio será o padrão" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridDate">
                            <Form.Label>Data</Form.Label>
                            <div>
                                <DatePicker
                                    selected={startDate}
                                    onChange={date => setStartDate(date.withoutTime())}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Digite ou clique aqui"
                                    disabledKeyboardNavigation />
                            </div>
                        </Form.Group>
                    </Form.Row>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar a lista
                        </Button>
                        <Button color="success" onClick={cleanList}>
                            Limpar a lista
                        </Button>
                    </div>
                    {list === null ?
                        (<Form.Row>
                            Não há estoques na lista
                        </Form.Row>)
                        : (
                            <Form.Row>
                                <Table
                                    tableHeaderColor="danger"
                                    tableHead={["Quantidade", "Produto", "Ações"]}
                                    tableData={getNf(list)}
                                />
                            </Form.Row>
                        )
                    }
                </Modal.Body>
                <Modal.Footer>
                    {url !== "" && <div className="d-flex justify-content-center">
                        <Button color="success" onClick={openLink}>
                            Baixar nota fiscal
                        </Button>
                    </div>}
                    {!loading && responseUri !== "" && <div className="d-flex justify-content-center">
                        <Button color="success" onClick={setLink}>
                            Gerar pdf da nota fiscal
                        </Button>
                    </div>}
                    <div className="d-flex justify-content-center">
                        <Button color="success" onClick={handleAddDevolutionNf}>
                            Concluir
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message={stored + " vendas adicionadas com sucesso"}
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                    <Backdrop
                        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                        open={loading}
                        onClick={() => { }}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
export default ModalCreateNf;
